import React from "react";

const DocumentProfilePencil = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#212121"
        d="m12.964 14.825-.63.63v.002h-.004l.631-.632h.003ZM12.326 17.667l-.002.632H6.35v-.632h5.975ZM11.436 15.457l.632-.632H6.35v.632h5.085ZM6.351 12.614h8.201l.085-.632H6.35v.632ZM9.09 7.047a.873.873 0 0 1-.644.262.873.873 0 0 1-.642-.262.876.876 0 0 1-.262-.644c0-.254.087-.469.262-.643a.873.873 0 0 1 .642-.263c.254 0 .469.088.643.263.175.174.262.389.262.643a.876.876 0 0 1-.262.644ZM6.351 9.708V9.63c0-.36.183-.633.548-.818.365-.186.88-.278 1.547-.278.667 0 1.183.092 1.548.278.365.185.547.458.547.818v.08h-4.19Z"
      />
      <path
        fill="#212121"
        fillRule="evenodd"
        d="M4.183 4.476c0-.581.471-1.053 1.052-1.053h9.948c.277 0 .543.11.74.304l3.738 3.693c.2.198.313.468.313.749v1.292c.154.078.298.182.426.31l.447.447a1.684 1.684 0 0 1 0 2.382l-.873.873v6.668c0 .582-.471 1.053-1.052 1.053H5.235a1.053 1.053 0 0 1-1.052-1.052V4.476Zm9 13.823h-.86l.003-.632.009-2.21v-.003l.629-.63 2.18-2.179.004-.03.073-.633c.16-1.552.136-6.316.121-7.896a.421.421 0 0 0-.159-.031H5.236a.421.421 0 0 0-.42.421v15.666c0 .232.188.42.42.42h5.643a8.626 8.626 0 0 0 2.304-2.263Zm4.347-8.04.488-.488-.488.488ZM15.974 6.95V4.671l2.735 2.7h-2.314a.421.421 0 0 1-.421-.42Zm3.98 3.268.446.446c.06.06.11.125.153.194a1.307 1.307 0 0 1-1.214 1.204l-1.36-1.36.486-.484a1.053 1.053 0 0 1 1.488 0Zm-5.219 5.928c1.17-.225 3.33-1.956 3.934-3.854l-1.14-1.14-3.894 3.895a.81.81 0 0 1 .392.71.809.809 0 0 1 .708.39Zm.075.437a.799.799 0 0 1 0 .002v-.002Zm-1.05-1.386Zm-.485.21-.31.31-.007 1.95h1.933l.314-.314a.337.337 0 0 0-.097-.2.344.344 0 0 0-.484.005l-.03.03-.347-.347.03-.03a.344.344 0 0 0 .005-.483.344.344 0 0 0-.484.004l-.03.03-.347-.347.03-.03a.344.344 0 0 0 .004-.484.337.337 0 0 0-.18-.094Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default DocumentProfilePencil;
